import React from 'react'
import { Route, Switch } from 'react-router-dom'

import './Content.css'

import Home from '../Home/Home'
import Estabelecimentos from '../Estabelecimentos/Estabelecimentos'
import Estado from '../Estado/Estado'
import Processos from '../Processos/Processos'
import Documentos from '../Documentos/Documentos'
import ImpressaoProcesso from '../Documentos/ImpressaoProcesso'
import Certidao from '../Certidao/Certidao'
import Anexo from '../Anexo/Anexo'
import AiView from '../Views/AiView'
import ProcessoCapa from '../Views/ProcessoCapa'
import DespachoView from '../DespachoView/DespachoView'
import Despacho from '../Despacho/Despacho'
import CertidaoView from '../CertidaoView/CertidaoView'
import Rotas from '../Rotas/Rotas'
import Estatisticas from '../Estatisticas/Estatisticas'
import NovoProcesso from '../Processos/NovoProcesso'
import BuscaProcesso from '../Processos/BuscaProcesso'
import Ai from '../Ai/Ai'
import Senha from '../Senha/Senha'
import CapaEdicao from '../CapaEdicao/CapaEdicao'
import CapaPafEdicao from '../CapaEdicao/CapaPafEdicao'
import Suporte from '../Suporte/Suporte'
import NovoChamado from '../Suporte/NovoChamado'
import MeusChamados from '../Suporte/MeusChamados'
import Chamado from '../Suporte/Chamado'
import Interno from '../Suporte/Interno'
import Resposta from '../Suporte/Resposta'
import NovaRota from '../Rotas/NovaRota'
import MinhasRotas from '../Rotas/MinhasRotas'
import CoordRotas from '../Rotas/CoordRotas'
import RotasView from '../Rotas/RotasView'
import ArquivaRota from '../Rotas/ArquivaRota'
import RotasCoord from '../Rotas/RotasCoord'
import PAF from '../PAF/PAF'
import NovoEstabelecimento from '../PAF/NovoEstabelecimento'
import BuscaPaf from '../PAF/BuscaPaf'
import DocumentosEstabelecimento from '../PAF/DocumentosEstabelecimento'
import AssociaProcesso from '../PAF/AssociaProcesso'
import NovoPaf from '../PAF/NovoPaf'
import DocumentosPaf from '../PAF/DocumentosPaf'
import PafCapa from '../Views/PafCapa'
import BuscaPafSetor from '../PAF/BuscaPafSetor'
import Mapa from '../Estatisticas/Mapa'
import Report from '../Estatisticas/Report'
import Indicadores from '../Estatisticas/Indicadores'
import EditCnpj from '../EdicaoCnpj/EditEstabelecimento'
import EditAnexo from '../Anexo/EditAnexo'
import Mensagem from '../Mensagem/Mensagem'
import MensagemFiscal from '../Mensagem/MensagemFiscal'
import Impressao from '../PAF/Impressao'
//Novo TV
import TermoDeVisita from '../TermoVisita/Biblioteca/TermoDeVisita'
import TermoDeVisitaView from '../TermoVisita/Biblioteca/TermoDeVisitaView'
import TermoDeVisitaTO from '../TermoVisita/Biblioteca/TermoDeVisitaTO'
import TermoDeVisitaTOView from '../TermoVisita/Biblioteca/TermoDeVisitaTOView'
import EditFisio from '../TermoVisita/Biblioteca/EditFisio'
import EditTO from '../TermoVisita/Biblioteca/EditTO'
//Novo Despacho
import DespachoNovo from '../DespachoNovo/DespachoNovo'
import DespachoNovoView from '../DespachoNovo/DespachoNovoView'
//Planilhas
import PlanilhaPE from '../Planilhas/PlanilhaPE'
import DashPE from '../Planilhas/DashPE'
//Rota Não Realizada
import RotaNaoRealizada from '../RotaNaoRealizada/RotaNaoRealizada'
import PesquisaNaoRealizada from '../RotaNaoRealizada/PesquisaNaoRealizada'
import CertidaoRotaFechada from '../RotaNaoRealizada/CertidaoRotaFechada'
//Chat
import Chat from '../Chat/Chat'
import InsertVectors from '../Vectors/InsertVectors'
//
import Terceirizadas from '../Terceirizadas/Terceirizadas'

import Agente from '../Estatisticas/Agente'
import PesquisaRegistro from '../Estatisticas/PesquisaRegistro'
import UsuariosAdmin from '../UsuariosAdmin/UsuariosAdmin'

export default class Content extends React.Component {
    render() {
        return (
            <div className="content">
                <Switch>
                    <Route exact path='/' component={Home} />
                    <Route exact path='/estabelecimentos' component={Estabelecimentos} />
                    <Route exact path='/estado' component={Estado} />
                    <Route exact path='/processos' component={Processos} />
                    <Route exact path={`/documentos/:id`} component={Documentos} />
                    <Route exact path={`/imprimirProcesso/:id`} component={ImpressaoProcesso} />
                    <Route exact path={`/certidao/:id`} component={Certidao} />
                    <Route exact path={`/anexo/:id`} component={Anexo} />
                    <Route exact path={`/aiView/:id`} component={AiView} />
                    <Route exact path={`/processoCapa/:id`} component={ProcessoCapa} />
                    <Route exact path={`/despacho/:id`} component={Despacho} />
                    <Route exact path={`/despachoView/:id`} component={DespachoView} />
                    <Route exact path={`/certidaoView/:id`} component={CertidaoView} />
                    <Route exact path='/rotas' component={Rotas} />
                    <Route exact path='/novaRota' component={NovaRota} />
                    <Route exact path='/minhasRotas' component={MinhasRotas} />
                    <Route exact path={`/rotasView/:id`} component={RotasView} />
                    <Route exact path={`/arquivaRota/:id`} component={ArquivaRota} />
                    <Route exact path='/rotasCoord' component={RotasCoord} />
                    <Route exact path='/coordRotas' component={CoordRotas} />
                    <Route exact path='/estatisticas' component={Estatisticas} />
                    <Route exact path='/novoProcesso' component={NovoProcesso} />
                    <Route exact path='/buscaProcesso' component={BuscaProcesso} />
                    <Route exact path={`/ai/:id`} component={Ai} />
                    <Route exact path='/senha' component={Senha} />
                    <Route exact path={`/capaEdicao/:id`} component={CapaEdicao} />
                    <Route exact path={`/capaPafEdicao/:id`} component={CapaPafEdicao} />
                    <Route exact path='/suporte' component={Suporte} />
                    <Route exact path='/novoChamado' component={NovoChamado} />
                    <Route exact path='/meusChamados' component={MeusChamados} />
                    <Route exact path={`/chamado/:id`} component={Chamado} />
                    <Route exact path='/interno' component={Interno} />
                    <Route exact path={`/resposta/:id`} component={Resposta} />
                    <Route exact path='/pafs' component={PAF} />
                    <Route exact path='/novoEstabelecimento' component={NovoEstabelecimento} />
                    <Route exact path='/buscaEstabelecimento' component={BuscaPaf} />
                    <Route exact path={`/documentosEstabelecimento/:id`} component={DocumentosEstabelecimento} />
                    <Route exact path={`/associaProcesso/:id`} component={AssociaProcesso} />
                    <Route exact path={`/novoPaf/:id`} component={NovoPaf} />
                    <Route exact path={`/documentosPaf/:id`} component={DocumentosPaf} />
                    <Route exact path={`/pafCapa/:id`} component={PafCapa} />
                    <Route exact path='/buscaPafSetor' component={BuscaPafSetor} />
                    <Route exact path='/mapa' component={Mapa} />
                    <Route exact path='/report' component={Report} />
                    <Route exact path='/indicadores' component={Indicadores} />
                    <Route exact path={`/editCnpj/:id`} component={EditCnpj} />
                    <Route exact path={`/editAnexo/:id`} component={EditAnexo} />
                    <Route exact path='/mensagem' component={Mensagem} />
                    <Route exact path='/mensagemFiscal' component={MensagemFiscal} />
                    <Route exact path='/suporteInterno' component={Interno} />
                    <Route exact path={`/imprimirPaf/:id`} component={Impressao} />
                    {/* Novo TV */}
                    <Route exact path='/fisio/:id' component={TermoDeVisita} />
                    <Route exact path='/tvFisioView/:id' component={TermoDeVisitaView} />
                    <Route exact path='/to/:id' component={TermoDeVisitaTO} />
                    <Route exact path='/tvToView/:id' component={TermoDeVisitaTOView} />
                    <Route exact path='/editFisio/:id' component={EditFisio} />
                    <Route exact path='/editTo/:id' component={EditTO} />
                    {/* Novo Depacho */}
                    <Route exact path='/despachoNovo/:id' component={DespachoNovo} />
                    <Route exact path='/despachoNovoView/:id' component={DespachoNovoView} />
                    {/* Planilhas */}
                    <Route exact path='/planilhaPE/' component={PlanilhaPE} />
                    <Route exact path='/dashPE/' component={DashPE} />
                    {/* Rotas Não Realizada */}
                    <Route exact path='/rotaNaoRealizada/' component={RotaNaoRealizada} />
                    <Route exact path='/pesquisaNaoRealizada/' component={PesquisaNaoRealizada} />
                    <Route exact path='/certidaoRotaFechada/:id' component={CertidaoRotaFechada} />
                    {/* Chat */}
                    <Route exact path='/chat/' component={Chat} />
                    {localStorage.tipo === "interno" ? (
                        <React.Fragment>
                            <Route exact path='/insertVectors' component={InsertVectors} />
                            <Route exact path='/usuariosAdmin' component={UsuariosAdmin} />
                        </React.Fragment>
                    ) : null}
                    <Route exact path='/buscaTerceirizados' component={Terceirizadas} />
                    <Route exact path='/ia' component={Agente} />
                    <Route exact path='/pesquisaRegistro' component={PesquisaRegistro} />
                </Switch>
            </div>
        )
    }
}